import { NgModule } from '@angular/core';
import {DateInputComponent} from './date-input.component';
import {SharedModule} from '../../shared/shared.module';

@NgModule({
    imports: [
        SharedModule,
        DateInputComponent
    ],
    exports: [
        DateInputComponent
    ]
})
export class DateInputModule { }
